export default [
  {
    id: 0,
    patentPending: true,
    slug: 'attach_cart',
    isBeta: false,
    name: 'ATTACH <label style="color: #00bfbd; font-weight: normal;">CART</label>',
    align: 'left',
    cta: 'Request a demo',
    clickMessage: 'Clicked request demo for Attach CART',
    description: 'MikMak Attach Cart increases add-to-carts within social media.',
    device: {
      color: 'white',
      rotation: '1deg'
    },
    images: {
      beauty: 'https://s3.amazonaws.com/attach-videos/758742_benefit-cart-demo-2-sm.m4v',
      apparel: 'https://s3.amazonaws.com/attach-videos/LmbP0f8tT2S3lVMsEQ17_Zappos%20-%20IG%20In-Feed%20Demo.mov',
      electronics: 'https://s3.amazonaws.com/attach-videos/bwLJ9EMQx2QdfE2gZRjK_Bose%20Sponsored%20Instagram%20Story.mp4'
    },
    features: [
      'Add-to-cart made easy',
      'Integrations with Shopify, Demandware, Magento, Amazon, Ulta, Walmart and more',
      'Full funnel attribution',
      'Bottom of funnel unit <i class="fa fa-cart-arrow-down" aria-hidden="true"></i>'
    ],
    learnMore: {
      text: 'See how Attach Cart outperformed a Fortune 1000\'s owned product details pages',
      href: '/attach/beauty'
    }
  },
  {
    id: 1,
    patentPending: true,
    slug: 'attach_multicart',
    isBeta: false,
    name: 'ATTACH <label style="color: #00bfbd; font-weight: normal;">MultiCart</label>',
    align: 'right',
    cta: 'Request a demo',
    clickMessage: 'Clicked request demo for Attach MultiCart',
    description: 'MikMak Attach MultiCart increases add-to-carts at shoppers\' preferred retailers.',
    device: {
      color: 'white',
      rotation: '1deg'
    },
    images: {
      CPG: 'https://s3.amazonaws.com/attach-videos/CShCDKG7QBK7QwUn9Ciu_Larabar%20Instagram%20Demo%20-%205.4.18.mov',
      beauty: 'https://s3.amazonaws.com/attach-videos/ZfkxrjZQdqg47yR0i0bQ_Olay%20Cinemagraph%20-%20MultiCart%20v2.mov'
    },
    features: [
      'In one click, shoppers choose where they want to checkout like Amazon, Ulta, Walmart and more',
      'Solves for your brand’s need for “fair and equitable distribution”',
      'Control your brand expression and data at the product page level even when you don’t own the eComm cart',
      'Bottom of funnel unit <i class="fa fa-cart-arrow-down" aria-hidden="true"></i>'
    ],
    learnMore: {
      text: 'Read how CPG brands improved shoppers\' journey with MultiCart',
      href: '/attach/food-and-beverage'
    }
  },
  {
    id: 2,
    patentPending: false,
    slug: 'attach_capture',
    isBeta: false,
    name: 'ATTACH <label style="color: #00bfbd; font-weight: normal;">CAPTURE</label>',
    align: 'left',
    cta: 'Request a demo',
    clickMessage: 'Clicked request demo for Attach CAPTURE',
    description: 'MikMak Attach Capture turns social engagement into an owned lead.',
    device: {
      color: 'white',
      rotation: '1deg'
    },
    images: {
      beauty: 'https://s3.amazonaws.com/attach-videos/eUOoMD5uTsOBrlvAEyvU_Make Up For Ever - Capture - 6.2.mov',
      apparel: 'https://s3.amazonaws.com/attach-videos/mNmLWLZOQ26r3f2zCzda_ua-capture-demo.mov'
    },
    features: [
      'Discover who your social leads are with automatic email capture upon swipe-up or click',
      'Import leads into your preferred CRM database',
      'Middle of funnel unit <i class="fa fa-user" aria-hidden="true"></i>'
    ],
    learnMore: {
      text: 'Discover how apparel brands collect first party data with Capture',
      href: '/attach/apparel-and-footwear'
    }
  }
]



// WEBPACK FOOTER //
// ./client/store/imports/AttachProducts.js